import { Controller } from "@hotwired/stimulus"

// Bootstrap's datetimepicker announces a picked date with jQuery's own trigger, which never
// reaches a native `addEventListener` (dispatches no DOM event for <input>) - so the form-wide
// validation and the picker's own "shown" notification both stay on jQuery bindings here rather
// than becoming data-actions.
const MIN_QUANTITY_ORDERED = 50;

export default class extends Controller {
  static get targets() { return ["form", "date", "next"]; }
  static get values() { return { pricePerUnit: Number, requestDateLeadTime: Number }; }

  connect() {
    window.ltCpbHelpers.init($(this.formTarget), this.pricePerUnitValue);

    this.onFormChange = () => this.validateForm();
    $(this.formTarget).on("change.customPackagingDetails", this.onFormChange);

    this.onDatepickerShow = () => {
      $(".bootstrap-datetimepicker-widget .datepicker").prepend(this.leadTimeToastHtml());
    };
    $(this.dateTarget).on("dp.show.customPackagingDetails", this.onDatepickerShow);

    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + this.requestDateLeadTimeValue * 7);

    $(this.dateTarget).datetimepicker({
      ...window.datetimepickerDefaults,
      minDate: futureDate,
      viewDate: futureDate,
    });

    this.validateForm();
  }

  disconnect() {
    $(this.formTarget).off("change.customPackagingDetails", this.onFormChange);
    $(this.dateTarget).off("dp.show.customPackagingDetails", this.onDatepickerShow);
  }

  increaseQuantityOrdered() {
    window.ltCpbHelpers.increaseQuantityOrdered();
    this.validateForm();
  }

  decreaseQuantityOrdered() {
    window.ltCpbHelpers.decreaseQuantityOrdered();
    this.validateForm();
  }

  nextStep(event) {
    event.preventDefault();
    this.formTarget.submit();
  }

  validateForm() {
    const nameCondition = this.formTarget.querySelector("#custom_packaging_bundle_name").value !== "";
    const expectedDateCondition = this.dateTarget.value !== "";
    const quantityOrderedCondition = window.ltCpbHelpers.getQuantityOrdered() >= MIN_QUANTITY_ORDERED;
    const expectedGiftValueCondition = this.formTarget.querySelectorAll(
      ".custom_packaging_bundle_expected_gift_value_cents input[type=radio]:checked"
    ).length > 0;

    const valid = nameCondition && expectedDateCondition && quantityOrderedCondition && expectedGiftValueCondition;
    this.nextTargets.forEach(button => button.classList.toggle("btn-disabled", !valid));
  }

  leadTimeToastHtml() {
    return `
      <div class="toast toast-warning shadowless banner">
        <div class="toast-container">
          <div class="toast-icon">
            <div class="toast-icon-container">
              <i class="icon-lasso-info"></i>
            </div>
          </div>
          <div class="toast-body">
            <div class="toast-description">
              Custom Packaging orders currently require ${this.requestDateLeadTimeValue} weeks lead time.
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
